// ── PC 전용 레이아웃 스타일 상수 ──────────────────────────────────────────────
// dark mode: CSS 변수 토큰 사용

import { C } from './constants';
import { stdBlackBtn, stdOutlineBtn } from '../adminlayout/designStandard';

// ── 전체 페이지 래퍼 ──────────────────────────────────────────────────────────
export const PAGE_WRAP = {
  display: 'flex', flexDirection: 'column',
  height: '100%', minHeight: 0,
  background: 'var(--bg)',
};

// 상단 헤더는 디자인 표준 텍스트 헤더(stdHeaderRow/stdPageTitle) 사용 — PcView/MobileView 참고 (2026-08-27 통일)

// ── 마케터 칩 선택 바 ─────────────────────────────────────────────────────────
export const CHIP_BAR = {
  display: 'flex', flexWrap: 'wrap', gap: 6,
  padding: '10px 20px',
  background: 'var(--bg-card)',
  borderBottom: `1px solid ${C.border}`,
  flexShrink: 0,
};

// ── 3패널 컨테이너 ────────────────────────────────────────────────────────────
export const PANELS = {
  display: 'flex',
  flex: 1,
  minHeight: 0,
  overflow: 'hidden',
};

// 패널 공통 베이스
const panelBase = {
  display: 'flex', flexDirection: 'column',
  overflow: 'hidden',
  background: 'var(--bg-card)',
};

// 3패널 모두 동일 너비 — flex:1 (1/3씩 균등 분할)
export const LEFT_PANEL = {
  ...panelBase,
  flex: 1, minWidth: 0,
  borderRight: `1px solid ${C.border}`,
};

export const CENTER_PANEL = {
  ...panelBase,
  flex: 1, minWidth: 0,
  borderRight: `1px solid ${C.border}`,
};

export const RIGHT_PANEL = {
  ...panelBase,
  flex: 1, minWidth: 0,
};

// ── 패널 타이틀 바 ────────────────────────────────────────────────────────────
export const PANEL_TITLE = {
  fontSize: 11, fontWeight: 700, color: C.subDark,
  background: 'var(--bg-subtle)',
  borderBottom: `1px solid ${C.border}`,
  padding: '7px 12px',
  flexShrink: 0,
  letterSpacing: '0.05em',
  textTransform: 'uppercase',
};

// ── 스크롤 영역 ───────────────────────────────────────────────────────────────
export const SCROLL = { flex: 1, overflowY: 'auto', overflowX: 'hidden' };

// ── 빈 상태 텍스트 ────────────────────────────────────────────────────────────
export const emptyTxt = {
  fontSize: 13, color: C.sub, textAlign: 'center', padding: '24px 12px',
};

// ── 우 패널 입력 폼 스타일 ────────────────────────────────────────────────────
export const FORM_WRAP = {
  padding: '10px 12px', display: 'flex', flexDirection: 'column', gap: 8, flexShrink: 0,
};
export const labelSt = {
  fontSize: 11, color: C.subDark, marginBottom: 2, display: 'block', fontWeight: 600,
};
export const inputSt = {
  fontSize: 13, padding: '5px 8px',
  border: `1px solid ${C.border}`, borderRadius: 5,
  outline: 'none', width: '100%', boxSizing: 'border-box',
  background: 'var(--bg-card)', color: 'var(--text)',
  minWidth: 0, maxWidth: '100%', minHeight: 34,
};
// 주요 CTA = 표준 검정 버튼 / 보조 = 표준 흰 외곽선 버튼 (파랑 primary 제거, 2026-08-27 디자인 통일)
export const btnPri = { ...stdBlackBtn, width: '100%' };
export const btnSec = { ...stdOutlineBtn, width: '100%' };
export const btnDang = {
  fontSize: 11, padding: '3px 7px', borderRadius: 4,
  border: '1px solid #fca5a5', background: 'var(--bg-card)', color: '#dc2626',
  cursor: 'pointer', flexShrink: 0,
};

// ── 매장카드 상세 행 스타일 ───────────────────────────────────────────────────
export const dRow   = {
  display: 'flex', alignItems: 'center', gap: 4, padding: '3px 0', fontSize: 11,
};
export const dDate  = { color: C.sub, width: 30, flexShrink: 0 };
export const dLabel = {
  color: C.subDark, flex: 1,
  overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap',
};
export const dAmt   = {
  fontWeight: 700, fontVariantNumeric: 'tabular-nums', flexShrink: 0,
};
export const dOrig  = { fontSize: 10, color: C.sub, flexShrink: 0 };
